/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { Form } from '@organisms';

import PlaylistSelect from '../PlaylistSelect';

const PlaylistField = ({ onChange, ...props }) => (
  <Form.Item {...props}>
    <PlaylistSelect onChange={onChange} />
  </Form.Item>
);

export default PlaylistField;
